import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Sidebar from "./components/Sidebar";
import CreateInvoice from "./components/CreateInvoice";
import AddItem from "./components/AddItem";
import ItemMapping from "./components/ItemMapping";

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* Sidebar */}
        <Sidebar />

        {/* Main Content */}
        <div className="main-content">
          <Routes>
            <Route path="/" element={<CreateInvoice />} />
            <Route path="/add-item" element={<AddItem />} />
            <Route path="/item-mapping" element={<ItemMapping />} />
            {/* Add more routes for future features */}
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;